export default [
  {
    path: "/programmes/:programmeId/scenarios/:id/",
    name: "scenario-editor",
    component: () => import("@/features/scenario-editor/pages/ScenarioEditorPage.vue"),
    props: (route) => ({
      id: Number(route.params.id),
      scenarioId: Number(route.params.id),
      programmeId: Number(route.params.programmeId),
    }),
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Scenarios",
      title: "Scenario Editor",
      breadcrumbs: [
        { name: "Programmes", route: "project-list" },
        { name: "Scenario Select", route: "project-workspace" },
        { name: "Scenario Editor", route: "scenario-editor" },
      ],
    },
  },

  {
    path: "/scenarios/:id/",
    name: "scenario-editor-legacy",
    redirect: (to) => ({
      name: "project-list",
      query: {
        scenarioId: to.params.id,
        routeIssue: "missing-programme-id",
      },
    }),
  },
];